export enum CupStates {
  WAITING_FOR_FINISH = 'WAITING_FOR_FINISH',
  WAITING_FOR_VALIDATION = 'WAITING_FOR_VALIDATION',
  WAITING_FOR_RATING_CALCULATION = 'WAITING_FOR_RATING_CALCULATION',
  FINISHED = 'FINISHED',
}
